var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-container-wrapper",
      class: { "has-logo": _vm.showLogo },
      style: { width: _vm.sidebarWidth },
    },
    [
      _c(
        "div",
        { staticClass: "sidebar-inner" },
        [
          _vm.showLogo
            ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
            : _vm._e(),
          _c(
            "el-scrollbar",
            { attrs: { "wrap-class": "scrollbar-wrapper" } },
            [
              _c(
                "el-menu",
                {
                  attrs: {
                    "default-active": _vm.activeMenu,
                    collapse: _vm.isCollapse,
                    "background-color": _vm.variables.menuBg,
                    "text-color": _vm.variables.menuText,
                    "unique-opened": true,
                    "active-text-color": _vm.variables.menuActiveText,
                    "collapse-transition": false,
                    mode: "vertical",
                  },
                },
                _vm._l(_vm.sidebarRouters, function (route, index) {
                  return _c("sidebar-item", {
                    key: route.path + index,
                    attrs: { item: route, "base-path": route.path },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("div", {
            staticClass: "sidebar-resizer",
            attrs: { title: "拖拽调整宽度" },
            on: { mousedown: _vm.handleMouseDown },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }